import { Button } from "@/components/ui/button";
import type { RefindBlame } from "@/lib/setup/refind";

/** ③: the sample is mostly off the question and the grades look fair, so the
 *  seeds are the problem — offer to re-find them (spec 2026-10-31 §1). */
export function OffTopicBox({ off, total, basis, blame, onRefind }: {
  off: number;
  total: number;
  /** "lanes": counts are ②'s quick check over the seeds' papers, not the sample's grades. */
  basis: "lanes" | "sample";
  blame: RefindBlame | null;
  onRefind: () => void;
}) {
  return (
    <section aria-label="Off-topic sample" className="flex flex-col gap-2 rounded-lg border border-primary/40 bg-primary/5 p-4">
      <span className="font-medium">
        {basis === "lanes"
          ? `${off} of the ${total} papers your seeds bring in are off your question`
          : `${off} of ${total} papers are off your question`}
      </span>
      <p className="text-sm text-muted-foreground">
        {basis === "lanes"
          ? "That's from the quick check at step 2, so the seeds are pulling in the wrong papers."
          : "The grades look fair, so the seeds are pulling in the wrong papers."}
        {blame ? ` ${blame.offTopic} of the ${off} came from “${blame.label}”.` : ""}
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <Button onClick={onRefind}>Re-find seeds →</Button>
        <span className="text-sm text-muted-foreground">Grades wrong instead? Mark those papers ✕ and we'll suggest a sharper question.</span>
      </div>
    </section>
  );
}
